import { Directive, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { ILightWeightArea, ILightWeightObject } from '@fi-shared/models';
import { IFiCheckBoxChangeEvent, IFiCheckboxItem } from '@fi-shared/fi-checkbox2/fi-checkbox2';
import { AppTextService } from '@fi-shared/app-text';
import { FiAccessRightHelperService } from '@fi-shared/fi-shared-services/fi-access-right-helper.service';
import { ObjectTypes } from '@fi-shared/types';

@Directive()
export abstract class FiAccessRightFiltersManualSelectionBaseDirective
    extends ControlValueAccessorValidatorBase<number[]>
    implements OnInit
{
    @Input() initialSelectionItemIds: number[] = [];
    @Input() accessRightCoreItems: ILightWeightObject[] | ILightWeightArea[] = [];
    @Input() items: ILightWeightObject[] | ILightWeightArea[] = [];

    @Input() disableUncheck: boolean;
    @Input() required: boolean = true;

    itemsListData: IFiCheckboxItem;
    itemsOutOfScope: ILightWeightObject[] | ILightWeightArea[] = [];
    ObjectType: ObjectTypes;

    constructor(private injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.setServices();

        this.itemsOutOfScope = this.fiAccessRightHelperService.getOutOfScopeItems(
            this.accessRightCoreItems,
            this.items,
        );
        this.itemsListData = this.getItemsListData();
    }

    private getItemsListData(): IFiCheckboxItem {
        if (this.ObjectType === ObjectTypes.Role || this.ObjectType === ObjectTypes.BusinessArea) {
            const label: string = this.appTextService.get(
                this.ObjectType === ObjectTypes.Role ? 'common.roles' : 'common.business_areas',
            );
            return this.fiAccessRightHelperService.getLightWeightItemCheckboxListData(
                this.accessRightCoreItems,
                this.itemsOutOfScope,
                label,
            );
        }
        if (this.ObjectType === ObjectTypes.Area)
            return this.fiAccessRightHelperService.getAreaCheckboxListData(
                this.accessRightCoreItems as ILightWeightArea[],
                this.itemsOutOfScope as ILightWeightArea[],
            );
    }

    getDisabledItemIds(): number[] {
        return this.disableUncheck ? this.initialSelectionItemIds : [];
    }

    canChangeAccessRight($event: IFiCheckBoxChangeEvent): Promise<boolean> {
        return this.fiAccessRightHelperService.canChangeAccessRight({
            $event,
            objectType: this.ObjectType,
            notAvailableItemIds: this.getNotAvailableItemIds(),
            selectedItemIds: this.ngModel,
        });
    }

    private getNotAvailableItemIds(): number[] {
        if (this.ObjectType === ObjectTypes.Area)
            return this.fiAccessRightHelperService.getAreaWithChildrenIds(this.itemsOutOfScope as ILightWeightArea[]);

        return this.itemsOutOfScope.map((item) => item.Id);
    }

    onSelectionChange() {
        this.ngModelChange.emit(this.ngModel);
    }

    private appTextService: AppTextService;
    protected fiAccessRightHelperService: FiAccessRightHelperService;
    private setServices() {
        this.appTextService = this.injector.get(AppTextService);
        this.fiAccessRightHelperService = this.injector.get(FiAccessRightHelperService);
    }
}
